<template>
  <v-card tile>
    <v-progress-linear
      :value="status.progress"
      :buffer-value="status.buffered"
      buffer
      class="my-0"
      height="3"
      color="#D0DFFE"
    ></v-progress-linear>

    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{ guide ? guide.title : '-' }}</v-list-tile-title>
          <v-list-tile-sub-title
            v-if="guide && guide.subtitle"
          >{{ guide.subtitle }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-spacer></v-spacer>

        <v-list-tile-action>
          <v-btn icon @click="seek(-10)" :disabled="status.waiting">
            <v-icon>fast_rewind</v-icon>
          </v-btn>
        </v-list-tile-action>

        <v-list-tile-action v-if="status.paused">
          <v-btn icon @click="audio.play()" :loading="status.waiting">
            <v-icon>play_arrow</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action v-else>
          <v-btn icon @click="audio.pause()" :loading="status.waiting">
            <v-icon>pause</v-icon>
          </v-btn>
        </v-list-tile-action>

        <v-list-tile-action>
          <v-btn icon @click="seek(10)" :disabled="status.waiting">
            <v-icon>fast_forward</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
export default {

  name: 'Player',

  data() {
    return {
      guide: null,
      audio: null,
      status: {
        paused: true,
        waiting: true,
        progress: 0,
        buffered: 0,
      },
    };
  },

  methods: {
    play(guide) {
      if (this.audio) this.stop();

      this.guide = guide;
      this.audio = new Audio(guide.file);

      this.audio.addEventListener('timeupdate', () => {
        if (this.audio) {
          this.status.progress = this.audio.currentTime / this.audio.duration * 100;
        }
      });

      this.audio.addEventListener('ended', () => {
        this.$emit('ended');
      });

      this.audio.addEventListener('play', () => {
        this.status.paused = false;
      });

      this.audio.addEventListener('pause', () => {
        this.status.paused = true;
      });

      this.audio.addEventListener('waiting', () => {
        this.status.waiting = true;
      });

      this.audio.addEventListener('playing', () => {
        this.status.waiting = false;
      });

      this.audio.addEventListener('progress', () => {
        if (this.audio) {
          try {
            const buffered = this.audio.buffered.end(0) / this.audio.duration * 100;
            if (buffered >= this.status.buffered) {
              this.status.buffered = buffered;
            }
          } catch (e) {
            //
          }
        }
      });

      this.audio.addEventListener('canplaythrough', () => {
        if (this.audio) {
          // Not 100% quaranteed but we dont have progress end event guarantee
          // so other option is to hack something with timers.
          this.status.buffered = 100;
        }
      });

      this.audio.play();
    },

    stop() {
      this.audio.pause();
      this.audio.load();
      this.audio = null;
      this.guide = null;

      // Reset status
      this.status = {
        paused: true,
        waiting: true,
        progress: 0,
        buffered: 0,
      };
    },

    togglePlay() {
      if (this.audio.paused) this.audio.play();
      else this.audio.pause();
    },

    seek(seconds) {
      if (seconds > 0 && this.audio.currentTime + seconds < this.audio.duration) {
        this.audio.currentTime += seconds;
      } else if (this.audio.currentTime + seconds > 0) {
        this.audio.currentTime += seconds;
      }
    },
  },

};
</script>
